import { Component } from '@verndale/core';
import { tns } from 'tiny-slider/src/tiny-slider';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      container: this.el.querySelector('.two-four-card-array__small-cards'),
      slider: this.el.querySelector('.two-four-card-array__listing'),
      sliderButtons: this.el.querySelector('.two-four-card-array__buttons')
    };

    if (this.dom.container) this.dom.container.dataset.itemCount = this.dom.slider.children.length;

    this.initSlider();
  }

  initSlider() {
    tns({
      container: this.dom.slider,
      controlsContainer: this.dom.sliderButtons,
      items: 1,
      gutter: 20,
      slideBy: 'page',
      loop: false,
      nav: false,
      preventScrollOnTouch: 'auto',
      responsive: {
        768: {
          items: 2
        },
        1024: {
          disable: true
        }
      }
    });
  }
}

export default Module;
